import { render, staticRenderFns } from "./edit-zip.component.vue?vue&type=template&id=5756741b&scoped=true"
import script from "./edit-zip.component.vue?vue&type=script&lang=js"
export * from "./edit-zip.component.vue?vue&type=script&lang=js"
import style0 from "./edit-zip.component.vue?vue&type=style&index=0&id=5756741b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756741b",
  null
  
)

export default component.exports